import { render } from "./EmployeeProfile.vue?vue&type=template&id=0b511808&ts=true"
import script from "./EmployeeProfile.vue?vue&type=script&lang=ts"
export * from "./EmployeeProfile.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__